// PAPERLIKE CUSTOM — Paperlike-built, no vanilla equivalent

if (!window.customElements.get('back-in-stock-modal')) {
  class BackInStockModal extends HTMLElement {
    constructor() {
      super();
      this.publicApiKey = this.dataset.apiKey;
      this.emailList = this.dataset.emailList;
      this.successMessage = this.querySelector('[data-success-message]');
      this.errorMessage = this.querySelector('[data-error-message]');
      
      this.themeJS = null;
      this.initModal();
      this.initBackInStockForm();
    }

    connectedCallback() {
      this.loadThemeJS();
      this.attachKeyboardAccessibility();
    }

    selectors = {
      closeButton: '[data-close]',
      modal: '.popup-modal__overlay--bis',      
      openButton: '[type="bis-modal-trigger"]',
    }

    classes = {
      active: 'active',
      animated: 'section__animation-applied',
      complete: 'complete',
      hidden: 'hidden',
      modalActive: 'variant-modal-active',
      selected: 'selected',
      show: 'show',
      subdued: 'subdued',
      subduedBtn: 'button--subdued'
    }

    attributes = {
      disabled: 'disabled'
    }

    async loadThemeJS() {
      this.themeJS = await import(themeVariables.urls.theme_js);
    }

    initBackInStockForm() {
      this.form = this.querySelector('[data-bis-form]');
      if (this.form) this.form.addEventListener('submit', () => this.handleFormSubmit());
    }

    initModal() {
      this.modal = this.querySelector(this.selectors.modal);
      this.closeButton = this.querySelector(this.selectors.closeButton);

      // PAPERLIKE PATCH (2026-09-11): delegated listener instead of binding each trigger at construct time —
      // triggers inside <buy-buttons> are replaced by theme.js on variant change and would lose bound handlers.
      document.addEventListener('click', (event) => {
        const trigger = event.target.closest(this.selectors.openButton);
        if (trigger) this.open(trigger);
      });
      document.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        const trigger = event.target.closest?.(this.selectors.openButton);
        if (!trigger) return;
        event.preventDefault();
        this.open(trigger);
      });
      this.closeButton?.addEventListener('click', () => this.close())
    }

    toggleModalData(trigger) {
      const variantId = trigger.dataset.variantId;
      const variantTitle = trigger.dataset.variantTitle;

      const variantInput = this.modal.querySelector('[name="variant-id"]');
      if(variantInput && variantId) variantInput.value = variantId;

      const variantTitleEls = this.modal.querySelectorAll('[data-variant-name]');
      if (variantTitle && variantTitleEls.length) {
        variantTitleEls.forEach(el => {
          el.innerText = variantTitle.replace('#', '"');
          el.setAttribute('data-variant-name', variantTitle.replace('#', '"'));
        });
      }
    }

    toggleModal(open) {
      this.toggleClass(document.body, this.classes.modalActive, open);
      this.modal.style.display = open ? 'flex' : 'none';

      // Add or remove the data attribute based on the open state
      if (open) {
        this.modal.setAttribute('data-is-open', '');
         // Use requestAnimationFrame to apply the transition class after the display change
          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              this.addClass(this.modal, 'is-visible'); // Add your transition class
            });
          });
      } else {
        this.modal.removeAttribute('data-is-open');
        this.removeClass(this.modal, 'is-visible');
      }
      
      this.firstOption = this.querySelector(this.selectors.familyCards);
      
      if (open) {
        this.addClass(this.familyCardsWrapper, this.classes.animated);
        document.addEventListener("keydown", this.handleEscapeKey.bind(this));
      } else {
        this.openButton?.focus();
        document.removeEventListener("keydown", this.handleEscapeKey.bind(this));
      }
    }
    
    open(trigger) {
      this.openButton = trigger; // PAPERLIKE PATCH (2026-09-11): remembered so close() can return focus
      this.toggleModal(true);
      this.toggleModalData(trigger);
    }
    
    close() {
      this.toggleModal(false);
    }
    
    handleEscapeKey(event) {
      if (event.key === "Escape") this.close();
    }

    attachKeyboardAccessibility() {
      const handleVariantSelection = (event) => {
        if (event.type === "click" || event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          event.target.click();
        }
      };
  
      const attachListeners = (selector) => {
        this.querySelectorAll(selector).forEach((item) => {
          item.addEventListener("keydown", handleVariantSelection);
        });
      };
  
      attachListeners(this.selectors.familyCards);
      attachListeners(this.selectors.modelCards);
      attachListeners(this.selectors.modalPrevious);
    }

    addClass(el, name) {
      el?.classList.add(name);
    }

    removeClass(el, name) {
      el?.classList.remove(name);
    }

    toggleClass(el, name, condition) {
      el?.classList.toggle(name, condition);
    }

    handleFormSubmit() {
      event.preventDefault();
      const form = event.target;
      const emailAddress = form.querySelector('[name="email"]').value;
      const variantId = form.querySelector('[name="variant-id"]').value;
      const subscribing = form.querySelector('[name="subscribe"]')?.checked;
      const submitButton = form.querySelector('button[type="submit"]');
    
      const bisData = {
        data: {
          type: "back-in-stock-subscription",
          attributes: {
            profile: {
              data: {
                type: "profile",
                attributes: {
                  email: emailAddress
                }
              }
            },
            channels: ["EMAIL"]
          },
          relationships: {
            variant: {
              data: {
                type: "catalog-variant",
                id: `$shopify:::$default:::${variantId}`
              }
            }
          }
        }
      };

      const options = {
        method: 'POST',
        headers: {
          accept: 'application/vnd.api+json',
          revision: '2025-04-15',
          'content-type': 'application/vnd.api+json'
        },
        body: JSON.stringify(bisData)
      };
      
      fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions?company_id=${this.publicApiKey}`, options)
        .then(res =>  {
          console.log(res, res.ok);

          const formFields = this.modal.querySelector('.back-in-stock__modal--form-fields');

          if (res.ok) {
            // Hide the form fields
            if (formFields) formFields.style.display = 'none';

            // Show the success message
            this.successMessage.classList.add('active');

            // ✅ Don't hide it after 5 seconds anymore
          } else {
            // Show error message for 5s (unchanged)
            this.errorMessage.classList.add('active');
            setTimeout(() => {
              this.errorMessage.classList.remove('active');
            }, 5000);
          }

          if (!subscribing && submitButton) submitButton.removeAttribute('aria-busy');
        })
        .catch(err => console.error(err));


          
      if (subscribing) {
        const subscribeData = {
          data: {
            type: "subscription",
            attributes: {
              profile: {
                data: {
                  type: "profile",
                  attributes: {
                    subscriptions: {
                      email: {
                        marketing: {
                          consent: "SUBSCRIBED"
                        }
                      },
                    },
                    email: emailAddress
                  }
                }
              },
              custom_source: "Back in Stock"
            },
            relationships: {
              list: {
                data: {
                  type: "list",
                  id: this.emailList
                }
              }
            }
          }
        };
  
        const options = {
          method: 'POST',
          headers: {
            accept: 'application/vnd.api+json',
            revision: '2025-04-15',
            'content-type': 'application/vnd.api+json'
          },
          body: JSON.stringify(subscribeData) 
        };

        fetch(`https://a.klaviyo.com/client/subscriptions?company_id=${this.publicApiKey}`, options)
          .then(res =>  {
            if(!res.ok) {
              this.errorMessage.classList.add('active');
              setTimeout(() => {
                this.errorMessage.classList.remove('active');
              }, 5000);
            }
            if (submitButton) submitButton.removeAttribute('aria-busy');
          })
          .catch(err => console.error(err));
        
      }
    }

    get isLockingNeeded() {
      return true;
    }
    get requiresBodyAppended() {
      return true;
    }

  };                         
  window.customElements.define('back-in-stock-modal', BackInStockModal);
}

